import type { Components } from '@mildang/mui';
import { autocompleteClasses } from '@mildang/mui';
import { outlinedInputClasses } from '@mildang/mui';
import type { Theme } from '@mildang/mui';
import { token } from '@mildang/styled-system/tokens';

const createAutocomplete = ({ shadows, typography, palette }: Theme): Components => ({
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        [`& .${outlinedInputClasses.root}`]: {
          padding: 8,
          paddingLeft: 12,
          alignContent: 'center',
          height: 'initial',
          [`& .${autocompleteClasses.input}`]: {
            height: 'initial',
            // paddingLeft: '12.8px',
            paddingBottom: '0px',
            paddingTop: '0px',

            //             font-size: 15px;
            // line-height: 26px;
          },
        },
        '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
          padding: 0,
        },
      },
      paper: {
        boxShadow: shadows[4],
      },
      option: {
        '&[aria-selected="true"]': {
          // backgroundColor: palette.primary.main,
          backgroundColor: `${token('colors.brand.a1')} !important`,
          [`&.${autocompleteClasses.focused}`]: {
            backgroundColor: `${token('colors.brand.a3')} !important`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
              backgroundColor: palette.action.selected,
            },
          },
          // [`&.${autocompleteClasses.fo}`]: {
          //   backgroundColor: token('colors.brand.a2'),
          // },
        },
      },

      listbox: {
        padding: 0,
        [`& > li`]: {
          marginTop: 4,
        },
        [`& .${autocompleteClasses.option}`]: {
          marginTop: 0,
        },
        [`& li:last-of-type .${autocompleteClasses.groupUl}`]: {
          boxShadow: 'none',
        },
      },
      tag: {},
      groupLabel: {
        ...typography.caption1_R,
        paddingTop: 5,
        paddingBottom: 5,
        color: palette.text.tertiary,
        top: 0,
      },
      groupUl: {
        boxShadow: shadows[1],
        paddingBottom: 4,
        [`& .${autocompleteClasses.option}`]: {
          paddingLeft: 16,
          paddingRight: 16,
        },
      },
    },
  },
});

export default createAutocomplete;
